<template>
    <div style="width: 100%;height: 100%;background-color: white">
      <div style="height: 20px"></div>
      <div style="height: calc(100% - 20px);margin: 0 20px;overflow-y: auto">
        <div style="height: 50px;">
          <el-input prefix-icon="el-icon-search" placeholder="输入ICCID/号码搜索" v-model="searchKeyword" clearable style="width: 200px"></el-input>&nbsp;
          <el-button type="primary" @click="searchSimCard()">搜索</el-button>
          <el-button type="primary" @click="getQueryTable()">重置</el-button>
          <el-button type="primary" @click="updateSimCard('ICCID更新充值时间')">ICCID更新充值时间</el-button>
          <el-button type="primary" @click="updateSimCard('号码更新充值时间')">号码更新充值时间</el-button>
          <el-button type="success" @click="updateSimCard('批量刷新SIM卡状态')">批量刷新SIM卡状态</el-button>
          <el-button type="success" @click="refreshSimCard()">全量刷新SIM卡状态</el-button>
          <el-button icon="el-icon-download" type="success" @click="getAllDown">导出</el-button>
        </div>
        <div style="height: 50px;">
          <span>条件查询</span>
          <el-select v-fixZoom v-model="istype" placeholder="请选择">
            <el-option v-for="item in typeArr" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <span>&nbsp;&nbsp;过期日期：</span>
          <el-date-picker v-fixZoom :clearable="false" v-model="simDate" type="daterange" unlink-panels range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd" style="width: 400px">
          </el-date-picker>
          <span v-if="istype === 2">&nbsp;&nbsp;设备最后在线日期：</span>
          <el-date-picker v-fixZoom :clearable="false" v-if="istype === 2" v-model="lastonline" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"> </el-date-picker>
          <el-button v-if="!isStart" type="primary" @click="getByTime1()">查询</el-button>
          <el-button v-else type="primary" plain @click="getByTime1()">查询</el-button>
        </div>
        <div style="max-height: calc(100% - 150px);overflow-y: auto;">
          <el-table :data="tableData" border style="width: 100%;margin-top: 10px" highlight-current-row ref="singleTable">
            <el-table-column
              type="index"
              label="序号"
              width="100"
              align="center">
            </el-table-column>
            <el-table-column
              prop="iccid"
              label="ICCID"
              min-width="110"
              align="center">
            </el-table-column>
            <el-table-column
              prop="phonenum"
              label="号码"
              min-width="110"
              align="center">
            </el-table-column>
            <el-table-column
              prop="validdate"
              label="过期时间"
              min-width="140"
              align="center">
            </el-table-column>
            <el-table-column
              prop="modify_tm"
              label="上次刷新时间"
              min-width="140"
              align="center">
            </el-table-column>
            <el-table-column
              label="上次充值时间"
              min-width="140"
              align="center">
              <template slot-scope="scope">
                {{lastTime(scope.row.lastrecharge)}}
              </template>
            </el-table-column>
            <el-table-column
              prop="last_online"
              label="最后在线时间"
              min-width="140"
              align="center">
            </el-table-column>
          </el-table>
        </div>
        <div style="margin-top: 10px;height: 40px;text-align: center">
          <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
          </el-pagination>
        </div>
      </div>
      <el-dialog :title="openTitle" :visible.sync="updateShow" v-if="updateShow"
        width="550px" :show-close="true" :close-on-click-modal="false" center>
        <div style="width: 100%">
          <el-input type="textarea" :rows="4"
            placeholder="例：xxxxxxxxxxx,xxxxxxxxxxx, ..." v-model="textarea">
          </el-input>
          <div style="margin-top: 30px">
            <el-row style="margin: 0 30px">
              <el-col :span="12">
                <div class="cancel-btn" @click="updateShow = false">
                  <span>取消</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="send-btn" @click="commitUpdateSimCard()">
                  <span>确定</span>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-dialog>
    </div>
</template>

<script>
import {querysimcardinfo, refreshsimcardinfo, searchsimcard, updatesimcardiccid, updatesimcardphonenum, refreshsimcardinfobyiccid, querysimcardinfobydate} from '../../api/topUp'

export default {
  name: 'stateRefillCard',
  data () {
    return {
      tableData: [],
      showTable: [],
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      searchKeyword: '',
      openTitle: '',
      updateShow: false,
      textarea: '',
      placeholder: '',
      pickerOptions: {
        shortcuts: []
      },
      typeArr: [{id: 1, name: '过期日期查询SIM卡'}, {id: 2, name: '设备最后在线时间查询SIM卡'}],
      istype: 1,
      simDate: [],
      lastonline: '',
      isStart: true
    }
  },
  created () {
    let aa = window.location.host
    if (aa === 'elderhealth.wecare-u.net') {
      history.back()
    }
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    const date = new Date().format('yyyy-MM-dd')
    this.simDate = [date, date]
    this.getTimeObj()
    // console.log(this.$route.query.history)
    if (!this.$route.query.history) {
      this.getSimCardInfo()
    } else {
      this.getTimeMoment()
    }
  },
  mounted () {
  },
  watch: {
    searchKeyword: function () {
      // console.log(this.searchKeyword)
      if (this.searchKeyword === '') {
        this.getSimCardInfo()
      }
    }
  },
  methods: {
    getTimeMoment () {
      let sysDate = new Date()
      // 获取当前月的第一天
      let startDateTime = sysDate.getFullYear() + '-' + ((sysDate.getMonth() + 1) < 10 ? '0' + (sysDate.getMonth() + 1) : (sysDate.getMonth() + 1)) + '-' + '01'
      // 获取当前月的最后一天
      let lastDate = new Date(sysDate)
      lastDate.setMonth(sysDate.getMonth() + 1)
      lastDate.setDate(0)
      let endDateTime = lastDate.getFullYear() + '-' + ((lastDate.getMonth() + 1) < 10 ? '0' + (lastDate.getMonth() + 1) : (lastDate.getMonth() + 1)) + '-' + lastDate.getDate()
      // console.log(startDateTime, endDateTime)
      this.simDate = [startDateTime, endDateTime]
      this.getByTime1()
    },
    // 时间
    mGetDate (year, month) {
      const d = new Date(year, month, 0)
      return d.getDate()
    },
    getTimeObj () {
      const dataArr = []
      const data = new Date()
      data.setMonth(data.getMonth() + 1, 1)// 获取到当前月份,设置月份
      for (let i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        let m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        dataArr.push(data.getFullYear() + '-' + (m))
      }
      const endDate = []
      for (let i = 1; i < dataArr.length; i++) {
        const arr = dataArr[i].split('-')
        const obj = {}
        let endDay = ''
        if (arr[1][0] === '0') {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1][1]))
          obj.text = arr[0] + '年' + arr[1][1] + '月'
        } else {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1]))
          obj.text = arr[0] + '年' + arr[1] + '月'
        }
        obj.start = arr[0] + '-' + arr[1] + '-' + '01'
        obj.end = arr[0] + '-' + arr[1] + '-' + endDay
        endDate.push(obj)
      }
      const arrTime = [
        {
          text: '本月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1)
            picker.$emit('pick', [start, end])
          }
        }
      ]
      for (let i = 0; i < endDate.length; i++) {
        const item = {
          text: endDate[i].text,
          onClick (picker) {
            picker.$emit('pick', [endDate[i].start, endDate[i].end])
          }
        }
        arrTime.push(item)
      }
      this.pickerOptions.shortcuts = arrTime
    },
    updateSimCard (title) {
      this.textarea = ''
      this.openTitle = title
      this.updateShow = true
    },
    commitUpdateSimCard () {
      let arr = this.textarea.split(',')
      if (this.openTitle === '号码更新充值时间') {
        let data = {
          phonenum: arr
        }
        updatesimcardphonenum(data).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '已提交执行，需要花费5～10分钟，请稍后查看',
              type: 'success'
            })
            this.updateShow = false
          }
        }).catch(() => {})
      } else if (this.openTitle === 'ICCID更新充值时间') {
        let data = {
          iccid: arr
        }
        updatesimcardiccid(data).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '已提交执行，需要花费5～10分钟，请稍后查看',
              type: 'success'
            })
            this.updateShow = false
          }
        }).catch(() => {})
      } else if (this.openTitle === '批量刷新SIM卡状态') {
        let data = {
          iccid: arr
        }
        refreshsimcardinfobyiccid(data).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '已提交执行，需要花费5～10分钟，请稍后查看',
              type: 'success'
            })
            this.updateShow = false
          }
        }).catch(() => {})
      }
    },
    searchSimCard () {
      if (this.searchKeyword !== '') {
        let data = {
          iccid: this.searchKeyword
        }
        searchsimcard(data).then(res => {
          if (res.code === 200) {
            this.tableData = [res.data.simcard]
            this.totalCells = this.tableData.length
          }
        }).catch(() => {})
      }
    },
    refreshSimCard () {
      this.$confirm('请注意，全量刷新SIM卡状态，会消耗大量系统资源，耗时大约5～10分钟，是否继续？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        refreshsimcardinfo().then(res => {
          if (res.code === 200) {
            this.$message({
              message: '已提交执行，需要花费5～10分钟，请稍后查看',
              type: 'success'
            })
          }
        }).catch(() => {})
      }).catch(() => {})
    },
    lastTime (time) {
      if (time === '0000-00-00 00:00:00') {
        return ''
      } else {
        return time
      }
    },
    getQueryTable () { // 重置
      this.currentPage = 1
      this.pageSize = 10
      this.isStart = true
      this.istype = 1
      this.getSimCardInfo()
    },
    getByTime1 () {
      this.searchKeyword = ''
      this.currentPage = 1
      this.pageSize = 10
      this.isStart = false
      this.getByTime()
    },
    getByTime () { // 过期日期查询sim卡 / 设备最后在线时间查询sim卡
      let data = {
        from: this.simDate[0] + ' 00:00:00',
        to: this.simDate[1] + ' 59:59:59'
      }
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      if (this.istype === 2) { // 设备最后在线时间查询sim卡
        if (this.lastonline === '') {
          this.$message({
            type: 'warning',
            message: '请选择设备最后在线日期',
            duration: 3000
          })
          return
        }
        data.lastonline = this.lastonline + ' 59:59:59'
      }
      querysimcardinfobydate(params, data).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.simcards
          this.totalCells = res.data.cnt
        }
      }).catch(() => {})
    },
    getSimCardInfo () { // 表格
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      querysimcardinfo(params).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.simcards
          this.totalCells = res.data.cnt
        }
      }).catch(() => {})
    },
    handleSizeChange (val) {
      this.pageSize = val
      if (this.isStart) {
        this.getSimCardInfo()
      } else {
        this.getByTime()
      }
    },
    handleCurrentChange (val) {
      this.currentPage = val
      if (this.isStart) {
        this.getSimCardInfo()
      } else {
        this.getByTime()
      }
    },
    getAllDown () {
      this.$message({
        type: 'info',
        message: '数据加载中，请耐心等待。',
        duration: 0
      })
      if (this.searchKeyword === '') {
        if (this.isStart) { // 开始请求
          let params = {
            page: 1,
            size: 10
          }
          querysimcardinfo(params).then(res => {
            if (res.code === 200) {
              this.getSimCardInfoDown(res.data.cnt)
            }
          }).catch(() => {
            this.$message.closeAll()
          })
        } else { // 过期查询 最后在线时间查询
          let data = {
            from: this.simDate[0] + ' 00:00:00',
            to: this.simDate[1] + ' 59:59:59'
          }
          let params = {
            page: 1,
            size: 10
          }
          if (this.istype === 2) { // 设备最后在线时间查询sim卡
            if (this.lastonline === '') {
              this.$message({
                type: 'warning',
                message: '请选择设备最后在线日期',
                duration: 3000
              })
              return
            }
            data.lastonline = this.lastonline + ' 59:59:59'
          }
          querysimcardinfobydate(params, data).then(res => {
            if (res.code === 200) {
              this.getByTimeDown(res.data.cnt)
            }
          }).catch(() => {
            this.$message.closeAll()
          })
        }
      } else { // 搜索查询
        this.searchSimCardDown()
      }
    },
    getSimCardInfoDown (cnt) {
      let params = {
        page: 1,
        size: cnt
      }
      querysimcardinfo(params).then(res => {
        if (res.code === 200) {
          this.download2(res.data.simcards)
        }
      }).catch(() => {
        this.$message.closeAll()
      })
    },
    getByTimeDown (cnt) {
      let data = {
        from: this.simDate[0] + ' 00:00:00',
        to: this.simDate[1] + ' 59:59:59'
      }
      let params = {
        page: 1,
        size: cnt
      }
      if (this.istype === 2) { // 设备最后在线时间查询sim卡
        if (this.lastonline === '') {
          this.$message({
            type: 'warning',
            message: '请选择设备最后在线日期',
            duration: 3000
          })
          return
        }
        data.lastonline = this.lastonline + ' 59:59:59'
      }
      querysimcardinfobydate(params, data).then(res => {
        if (res.code === 200) {
          this.download2(res.data.simcards)
        }
      }).catch(() => {
        this.$message.closeAll()
      })
    },
    searchSimCardDown () {
      let data = {
        iccid: this.searchKeyword
      }
      searchsimcard(data).then(res => {
        if (res.code === 200) {
          let arr = [res.data.simcard]
          this.download2(arr)
        }
      }).catch(() => {
        this.$message.closeAll()
      })
    },
    download2 (arr) {
      console.log(11, arr)
      let arr1 = []
      for (let i = 0; i < arr.length; i++) {
        let obj = arr[i]
        obj.lastrechargeShow = this.lastTime(arr[i].lastrecharge)
        arr1.push(obj)
      }
      import('../../vendor/Export2Excel').then(excel => {
        const tHeader = ['ICCID', '号码', '过期时间', '上次刷新时间', '上次充值时间', '最后在线时间']
        const filterVal = ['iccid', 'phonenum', 'validdate', 'modify_tm', 'lastrechargeShow', 'last_online']
        const list = arr1
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: 'SIM卡过期状态'
        })
      })
      setTimeout(() => {
        this.$message.closeAll()
      }, 1500)
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'last_online') {
          if (v[j]) {
            return v[j]
          } else {
            return ''
          }
        } else {
          return v[j]
        }
      }))
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemlog/stateRefillCard.vue